import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = 'configuracion/valores-por-variables-de-seleccion/';

/**
 * GET Valores por Variable de Seleccion
 * @returns {Promise<Array<object>>}
 */
export const getValoresPorVariablesDeSeleccion = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Valor Por Variable De Seleccion
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getValorPorVariableDeSeleccion = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Valor Por Variable De Seleccion
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postValorPorVariableDeSeleccion = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Valor Por Variable De Seleccion
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchValorPorVariableDeSeleccion = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Valor Por Variable De Seleccion
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteValorPorVariableDeSeleccion = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
